
import { Component, Vue, Prop } from 'vue-property-decorator';
import { DeviceInfo, DeviceType, GPSReportModes } from '@/types/device-info';
import { validatePrivilege } from '@/utils/devices';
import { DevicePrivileges } from '@/constants/device_privileges';

@Component({
    components: {},
})
export default class DeviceTrackingMenu extends Vue {
    @Prop({ required: true })
    device!: DeviceInfo;

    @Prop({ required: true })
    onLocate!: (mode: string) => void;

    @Prop({ required: true })
    stopTracking!: () => void;

    DeviceTypeenum = DeviceType;
    protected GPSReportModes = GPSReportModes;
    protected validatePrivilege = validatePrivilege;
    protected DevicePrivileges = DevicePrivileges;

    validateRestricted() {
        return this.validatePrivilege(this.device.privilege, [DevicePrivileges.SuperOwner, DevicePrivileges.Owner]);
    }
}
